module.exports = __webpack_public_path__ + "static/media/mosfet_board_+_8-min.1979b4c9.jpg";